import styled from "styled-components"

export const StyledPage = styled.div`
  padding: 2rem;
  max-width: 90rem;
  margin: 0 auto;
`

export const EmptyCatalog = styled.div``
